import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * Homepage class.
 */
export default class CollectionHero extends withIntersectionObserver(Base, {
  threshold: 0.8,
}) {
  isVisible = false;
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'CollectionHero',
    refs: ['title', 'items[]'],
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    const tl = gsap.timeline();
    tl.to(this.$refs.title, {
      y: 0,
      duration: 0.8,
      ease: 'power4.out',
    });
    tl.to(
      this.$refs.items,
      {
        y: 0,
        duration: 0.8,
        stagger: 0.05,
        ease: 'power4.out',
      },
      '<+=0.05',
    );
  }
}
